import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import PropagateLoader from "react-spinners/HashLoader";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";

const Success = () => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const css1 = `display: block;`;
  const style = {
    position: "fixed",
  };
  const getAccounts = async () => {
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    return accounts[0];
  };
  useEffect(() => {
    getAccounts().then((account) => {
      const docRef = doc(db, "users", auth.currentUser.uid);
      getDoc(docRef).then((user) => {
        if (user.exists()) {
          if (user.data().tweetHandle != null && user.data().displayName) {
            setUser(user.data());
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
        signOut(auth);
      });
    });
  }, []);
  return (
    <div className="success">
      {loading && (
        <PropagateLoader
          color={"#4d00ac"}
          isLoading={loading}
          css={css1}
          style={style}
          size={60}
        />
      )}
      {!loading && (
        <div className="loaded">
          <div className="regis">
            <span>Yay, 🥳🥳</span>
            <img src="" alt=""></img>
            <span> You have successfully registered</span>
          </div>
          <div className="check">
            <span>
              Check your shareable Web3 profile at doxdom.com/{user.displayName}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Success;
